var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTagCreate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.7155 8.30134C18.1013 8.69648 18.0938 9.3296 17.6987 9.71546L11.5544 15.7155C11.3628 15.9026 11.104 16.005 10.8362 15.9998C10.5684 15.9946 10.3139 15.8821 10.1297 15.6876L7.27395 12.6724C6.89418 12.2714 6.91137 11.6385 7.31236 11.2587C7.71335 10.8789 8.34628 10.8961 8.72605 11.2971L10.8836 13.5751L16.3013 8.28454C16.6965 7.89869 17.3296 7.90621 17.7155 8.30134Z"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTagCreate);
export default __webpack_public_path__ + "static/media/tagCreate.1fdc3b6e.svg";
export { ForwardRef as ReactComponent };